import { render, staticRenderFns } from "./WordToPptPage.vue?vue&type=template&id=73892798"
import script from "./WordToPptPage.vue?vue&type=script&lang=ts"
export * from "./WordToPptPage.vue?vue&type=script&lang=ts"
import style0 from "./WordToPptPage.vue?vue&type=style&index=0&id=73892798&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports